// import React, { useState } from 'react'
// import "./refferalcodesandfriends.css"
// import { MdKeyboardArrowRight } from 'react-icons/md';
// import Modal from 'react-modal';
// import { RxCross2 } from 'react-icons/rx';

// const RefferalCodesAndFriends = () => {
//     const [activeTab, setActiveTab] = useState('commission');
//     const [isModalOpen, setModalOpen] = useState(false);

//     const handleTabClick = (tab) => {
//       setActiveTab(tab);
//     };

//     const handleModal = () =>{
//       setModalOpen(!isModalOpen);
//     }

//   return (

//     <div>
//       <div style={{marginTop:'15px'}} className='refferal-codes-and-friends'>
//         <div className='refferal-codes-and-friends-top'>
//           <div className='refferal-codes-created-main'>
//             <div className='refferal-codes-created-title'>
//               <span>Referral Code Created</span>
//             </div>
//             <span className='reffreral-code-created'>4
//               <span style={{color:'#B3BEC1',paddingLeft:"2px"}}>/20</span>
//             </span>
//           </div>
//           <div className='refferal-codes-created-main'>
//             <div className='refferal-codes-created-title'>
//               <span>Friends</span>
//             </div>
//             <span className='reffreral-code-created'>0</span>
//           </div>
//         </div>
//           <div className='create-code-button-main'>
//             <button onClick={handleModal}  className='create-code-button'>Create Code</button>
//           </div>
//       </div>
//        <div style={{marginTop:'15px'}} className='myrewards-commission-refferal-table'>
//                 <div className='commission-refferal-table-tabs'>
//                   <button onClick={() => handleTabClick('commission')} className={activeTab === 'commission' ? 'active' : ''}>Refferal Code</button>
//                   <button onClick={() => handleTabClick('referral')} className={activeTab === 'referral' ? 'active' : ''}>Friends</button>
//                 </div>

//                 {/* Conditional rendering based on active tab */}
//                 {activeTab === 'commission' ? (
//                   <div className='refferalcodesandfriends-refferal-table'>
//                   <div className='refferal-table-data'>
//                     <table>
//                       <thead>
//                         <tr className='refferal-table-header' style={{borderBottom:"1px solid #e4eaf019"}}>
//                           <th>Name</th>
//                           <th>Code</th>
//                           <th>Link</th>
//                           <th>Commission Rate</th>
//                           <th>Date Created</th>
//                           <th className='text-right'>Referrals</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr className='refferal-table-row'>
//                           <td>Username</td>
//                           <td className='table-refferal-code'>
//                             <span>yry34y</span>
//                             <img style={{width:"1rem"}} src='/assets/bcimages/bcaffiliate/copy_icon.svg'/>
//                           </td>
//                           <td className='table-refferal-code'>
//                             <span>https://bc.app/i-2tk15ylqo-n/</span>
//                             <img style={{width:"1rem"}} src='/assets/bcimages/bcaffiliate/copy_icon.svg'/>
//                           </td>
//                           <td className='table-refferal-code'>
//                             <span>25%</span>
//                           </td>
//                           <td>2024-12-13 17:34:59</td>
//                           <td className='text-right table-refferal-code-modal'>
//                           <span>0</span>
//                           <MdKeyboardArrowRight size={18}/>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//                 ) : (
//                   <div className='myrewards-refferal-table'>
//                     <div className='refferal-table-data'>
//                       <table>
//                         <thead>
//                           <tr className='refferal-table-header' style={{borderBottom:"1px solid #e4eaf019"}}>
//                             <th>Username</th>
//                             <th>Registration Date</th>
//                             <th>VIP Level</th>
//                             <th>Code</th>
//                             <th className='text-right'>Earned</th>
//                           </tr>
//                         </thead>
//                       </table>

//                     </div>
//                   </div>
//                 )}
//                 <div className='commission-refferal-table-border'></div>
//         </div>
//          {/* Referral Modal Component */}
//               <Modal
//                 isOpen={isModalOpen}
//                 onRequestClose={handleModal}
//                 contentLabel="Referral Terms & Conditions"
//                 className="create-campaign-modal"
//                 overlayClassName="custom-overlay"
//               >
//                 <h2>Create Code</h2>
//                 <button onClick={handleModal} className="close-modal-button">
//                   <RxCross2/>
//                 </button>
//                 <div
//                   className="modal-content-affiliate"
//                   style={{marginTop:"10px" }}
//                 >
//                   <div className='create-campaign-title'>
//                   <p>Campaign Name (Optional)</p>
//                   <div className='Create-code-modal-input'>
//                     <input placeholder='Enter Campaign Name'/>
//                   </div>
//                   </div>
//                   <div>
//                    <button className='create-campaign-button'>Create Campaign</button>
//                   </div>
//                 </div>
//               </Modal>
//     </div>
//   )
// }

// export default RefferalCodesAndFriends

// import React, { useState, useEffect } from 'react';
// import './refferalcodesandfriends.css';
// import { MdKeyboardArrowRight } from 'react-icons/md';
// import Modal from 'react-modal';
// import { RxCross2 } from 'react-icons/rx';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const RefferalCodesAndFriends = () => {
//     const [activeTab, setActiveTab] = useState('commission');
//     const [isModalOpen, setModalOpen] = useState(false);
//     const [isModalOpen1, setModalOpen1] = useState(false);
//     const [referralData, setReferralData] = useState([]);

//     const handleModal1 = () =>{
//         setModalOpen1(!isModalOpen1);
//     }

//     useEffect(() => {
//         const storedData = JSON.parse(localStorage.getItem('referralData')) || [];
//         setReferralData(storedData);
//     }, []);

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     const handleModal = () => {
//         setModalOpen(!isModalOpen);
//     };

//     const validateCampaignName = (name) => /^[a-zA-Z0-9]*$/.test(name);

//     const handleCreateCode = (campaignName) => {
//         if (referralData.length >= 20) {
//             toast.error('Maximum 20 referral codes allowed!');
//             return;
//         }

//         if (!campaignName.trim()) {
//           toast.error('Campaign name cannot be empty!');
//           return;
//       }

//         if (!validateCampaignName(campaignName)) {
//             toast.error('Campaign name can only contain letters and numbers!');
//             return;
//         }

//         const newCode = {
//             name: campaignName || `Campaign ${referralData.length + 1}`,
//             code: `sk${Math.random().toString(36).substr(2, 6)}`,
//             link: `https://bc.app/i-${Math.random().toString(36).substr(2, 10)}/`,
//             commissionRate: '25%',
//             dateCreated: new Date().toLocaleString(),
//             referrals: 0,
//         };

//         const updatedData = [...referralData, newCode];
//         setReferralData(updatedData);
//         localStorage.setItem('referralData', JSON.stringify(updatedData));
//         toast.success('Referral code created successfully!');
//         setModalOpen(false);
//     };

//     const handleCopy = (text, type) => {
//         navigator.clipboard.writeText(text)
//             .then(() => {
//                 toast.success(`${type} copied to clipboard!`);
//             })
//             .catch(() => {
//                 toast.error('Failed to copy. Try again.');
//             });
//     };

//     const clearData = () => {
//         localStorage.removeItem('referralData');
//         setReferralData([]);
//         toast.success('All referral codes have been deleted!');
//     };

//     return (
//         <div>
//             <ToastContainer/>
//             <button onClick={clearData} className='clear-data-button'>Clear All Referral Codes</button>
//             <div style={{ marginTop: '15px' }} className='refferal-codes-and-friends'>
//                 <div className='refferal-codes-and-friends-top'>
//                     <div className='refferal-codes-created-main'>
//                         <div className='refferal-codes-created-title'>
//                             <span>Referral Code Created</span>
//                         </div>
//                         <span className='reffreral-code-created'>
//                             {referralData.length}
//                             <span style={{ color: '#B3BEC1', paddingLeft: "2px" }}>/20</span>
//                         </span>
//                     </div>
//                     <div className='refferal-codes-created-main'>
//                         <div className='refferal-codes-created-title'>
//                             <span>Friends</span>
//                         </div>
//                         <span className='reffreral-code-created'>0</span>
//                     </div>
//                 </div>
//                 <div className='create-code-button-main'>
//                     <button onClick={handleModal} className='create-code-button'>Create Code</button>
//                 </div>
//             </div>

//             <div style={{ marginTop: '15px' }} className='myrewards-commission-refferal-table'>
//                 <div className='commission-refferal-table-tabs'>
//                     <button onClick={() => handleTabClick('commission')} className={activeTab === 'commission' ? 'active' : ''}>Referral Code</button>
//                     <button onClick={() => handleTabClick('referral')} className={activeTab === 'referral' ? 'active' : ''}>Friends</button>
//                 </div>
//                 <div className='commission-refferal-table-border'></div>

//                 {activeTab === 'commission' ? (
//                     <div className='refferalcodesandfriends-refferal-table'>
//                         <div className='refferal-table-data'>
//                             <table>
//                                 <thead>
//                                     <tr className='refferal-table-header' style={{ borderBottom: "1px solid #e4eaf019" }}>
//                                         <th>Name</th>
//                                         <th>Code</th>
//                                         <th>Link</th>
//                                         <th>Commission Rate</th>
//                                         <th>Date Created</th>
//                                         <th className='text-right'>Referrals</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {referralData.map((item, index) => (
//                                         <tr key={index} className='refferal-table-row'>
//                                             <td>{item.name}</td>
//                                             <td className='table-refferal-code'>
//                                                 <span>{item.code}</span>
//                                                 <img
//                                                     style={{ width: "1rem", cursor: "pointer" }}
//                                                     src='/assets/bcimages/bcaffiliate/copy_icon.svg'
//                                                     onClick={() => handleCopy(item.code, 'Code')}
//                                                 />
//                                             </td>
//                                             <td className='table-refferal-code'>
//                                                 <span>{item.link}</span>
//                                                 <img
//                                                     style={{ width: "1rem", cursor: "pointer" }}
//                                                     src='/assets/bcimages/bcaffiliate/copy_icon.svg'
//                                                     onClick={() => handleCopy(item.link, 'Link')}
//                                                 />
//                                             </td>
//                                             <td>{item.commissionRate}</td>
//                                             <td>{item.dateCreated}</td>
//                                             <td onClick={handleModal1} className='text-right table-refferal-code-modal'>
//                                                 <span>{item.referrals}</span>
//                                                 <MdKeyboardArrowRight size={18} />
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 ) : (
//                     <div className='myrewards-refferal-table'>
//                         <div className='refferal-table-data'>
//                             <table>
//                                 <thead>
//                                     <tr className='refferal-table-header' style={{ borderBottom: "1px solid #e4eaf019" }}>
//                                         <th>Username</th>
//                                         <th>Registration Date</th>
//                                         <th>VIP Level</th>
//                                         <th>Code</th>
//                                         <th className='text-right'>Earned</th>
//                                     </tr>
//                                 </thead>
//                             </table>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             <Modal
//                 isOpen={isModalOpen}
//                 onRequestClose={handleModal}
//                 contentLabel="Referral Terms & Conditions"
//                 className="create-campaign-modal"
//                 overlayClassName="custom-overlay"
//             >
//                 <h2>Create Code</h2>
//                 <button onClick={handleModal} className="close-modal-button">
//                     <RxCross2 />
//                 </button>
//                 <div className="modal-content-affiliate" style={{ marginTop: "10px" }}>
//                     <div className='create-campaign-title'>
//                         <p>Campaign Name (Optional)</p>
//                         <div className='Create-code-modal-input'>
//                             <input
//                                 placeholder='Enter Campaign Name'
//                                 onBlur={(e) => handleCreateCode(e.target.value.trim())}
//                             />
//                         </div>
//                     </div>
//                     <div>
//                         <button
//                             className='create-campaign-button'
//                             onClick={() => handleCreateCode('')}
//                         >
//                             Create Campaign
//                         </button>
//                     </div>
//                 </div>
//             </Modal>

//             <Modal
//                 isOpen={isModalOpen1}
//                 onRequestClose={handleModal1}
//                 contentLabel="Referral Terms & Conditions"
//                 className="Referral-Code-Details-modal"
//                 overlayClassName="custom-overlay"
//             >
//                 <h2>Create Code</h2>
//                 <button onClick={handleModal1} className="close-modal-button">
//                     <RxCross2 />
//                 </button>
//                 <div className="Referral-Code-Details-modal-content">
//                   <div className='refferal-codes-modal-inner'>
//                     <div className='refferal-codes-inner'>
//                       <div className='refferal-codes-table-inner-details'>
//                         <div className='inner-details-name'>
//                           <div>Name</div>
//                           <div className='inner-details-name-label'>hello</div>
//                         </div>
//                         <div className='inner-details-name'>
//                           <div>Code</div>
//                           <div className='inner-details-code-label'>
//                             2tkgwm82p
//                            <img  style={{ width: "1rem", cursor: "pointer" ,marginLeft:"5px"}} src='/assets/bcimages/bcaffiliate/copy_icon.svg'/>
//                           </div>
//                         </div>
//                         <div className='inner-details-name'>
//                           <div>Link</div>
//                           <div className='inner-details-code-label'>
//                             https://bcaffiliate.com/2tkgwm82p
//                            <img  style={{ width: "1rem", cursor: "pointer" ,marginLeft:"5px"}} src='/assets/bcimages/bcaffiliate/copy_icon.svg'/>
//                           </div>
//                         </div>
//                         <div className='inner-details-name'>
//                           <div>Date Created</div>
//                           <div className='inner-details-name-label'>2024-12-24 17:57:43</div>
//                         </div>
//                         <div className='inner-details-name'>
//                           <div>Refferals</div>
//                           <div className='inner-details-name-label'>0</div>
//                         </div>
//                         <div className='inner-details-name'>
//                           <div>Commission Rate</div>
//                           <div className='inner-details-name-label'>25%</div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//             </Modal>
//         </div>
//     );
// };

// export default RefferalCodesAndFriends;

import React, { useState, useEffect, useRef } from "react";
import "./refferalcodesandfriends.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoMdSearch } from "react-icons/io";
import ReactDatePicker from "react-datepicker";

const RefferalCodesAndFriends = () => {
  const [activeTab, setActiveTab] = useState("commission");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);
  const [referralData, setReferralData] = useState([]);
  const [selectedReferral, setSelectedReferral] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleModal1 = (referral = null) => {
    setSelectedReferral(referral);
    setModalOpen1(!isModalOpen1);
  };

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("referralData")) || [];
    setReferralData(storedData);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const validateCampaignName = (name) => /^[a-zA-Z0-9]*$/.test(name);

  const handleCreateCode = (campaignName) => {
    if (referralData.length >= 20) {
      toast.error("Maximum 20 referral codes allowed!");
      return;
    }

    if (!campaignName.trim()) {
      toast.error("Campaign name cannot be empty!");
      return;
    }

    if (!validateCampaignName(campaignName)) {
      toast.error("Campaign name can only contain letters and numbers!");
      return;
    }

    const newCode = {
      name: campaignName || `Campaign ${referralData.length + 1}`,
      code: `sk${Math.random().toString(36).substr(2, 6)}`,
      link: `https://bc.app/i-${Math.random().toString(36).substr(2, 10)}/`,
      commissionRate: "25%",
      dateCreated: new Date().toLocaleString(),
      referrals: 0,
    };

    const updatedData = [...referralData, newCode];
    setReferralData(updatedData);
    localStorage.setItem("referralData", JSON.stringify(updatedData));
    toast.success("Referral code created successfully!");
    setModalOpen(false);
  };

  const handleCopy = (text, type) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success(`${type} copied to clipboard!`);
      })
      .catch(() => {
        toast.error("Failed to copy. Try again.");
      });
  };

  const clearData = () => {
    localStorage.removeItem("referralData");
    setReferralData([]);
    toast.success("All referral codes have been deleted!");
  };

  const dropdownRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState("Commission Rewards");
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);

  const options = [
    { label: "Commission Rewards" },
    { label: "Refferal Rewards" },
  ];

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    setIsOptionsVisible(false);
  };

  const toggleOptions = () => {
    setIsOptionsVisible(!isOptionsVisible);
  };

  const refferalcodeData = [
    {
      username: "JohnDoe",
      userId: "12345",
      commissionRate: "5%",
      totalDeposits: "$500",
      registrationDate: "2024-01-15",
      totalCommission: "$25",
    },
    {
      username: "JaneSmith",
      userId: "67890",
      commissionRate: "4%",
      totalDeposits: "$700",
      registrationDate: "2024-01-10",
      totalCommission: "$28",
    },
    {
      username: "MikeBrown",
      userId: "54321",
      commissionRate: "6%",
      totalDeposits: "$600",
      registrationDate: "2023-12-20",
      totalCommission: "$36",
    },
    {
      username: "EmilyWhite",
      userId: "98765",
      commissionRate: "3.5%",
      totalDeposits: "$800",
      registrationDate: "2023-12-25",
      totalCommission: "$28",
    },
  ];

  return (
    <div>
      <ToastContainer />
      {/* <button onClick={clearData} className="clear-data-button">
        Clear All Referral Codes
      </button> */}
      <div style={{ marginTop: "15px" }} className="refferal-codes-and-friends">
        <div className="refferal-codes-and-friends-top">
          <div className="refferal-codes-created-main">
            <div className="refferal-codes-created-title">
              <span>Referral Code Created</span>
            </div>
            <span className="reffreral-code-created">
              {referralData.length}
              <span style={{ color: "#B3BEC1", paddingLeft: "2px" }}>/20</span>
            </span>
          </div>
          <div className="refferal-codes-created-main">
            <div className="refferal-codes-created-title">
              <span>Friends</span>
            </div>
            <span className="reffreral-code-created">0</span>
          </div>
        </div>
        <div className="create-code-button-main">
          <button onClick={handleModal} className="create-code-button">
            Create Code
          </button>
        </div>
      </div>

      <div
        style={{ marginTop: "15px" }}
        className="myrewards-commission-refferal-table"
      >
        <div className="commission-refferal-table-tabs">
          <button
            onClick={() => handleTabClick("commission")}
            className={activeTab === "commission" ? "active" : ""}
          >
            Referral Code
          </button>
          <button
            onClick={() => handleTabClick("referral")}
            className={activeTab === "referral" ? "active" : ""}
          >
            Friends
          </button>
        </div>
        <div className="commission-refferal-table-border"></div>

        {activeTab === "commission" ? (
          <div className="refferalcodesandfriends-refferal-table">
            <div className="refferal-table-data">
              <table>
                <thead>
                  <tr
                    className="refferal-table-header"
                    style={{ borderBottom: "1px solid #e4eaf019" }}
                  >
                    <th>Name</th>
                    <th>Code</th>
                    <th>Link</th>
                    <th>Commission Rate</th>
                    <th>Date Created</th>
                    <th className="text-right">Referrals</th>
                  </tr>
                </thead>
                <tbody>
                  {referralData.map((item, index) => (
                    <tr key={index} className="refferal-table-row">
                      <td>{item.name}</td>
                      <td className="table-refferal-code">
                        <span>{item.code}</span>
                        <img
                          style={{ width: "1rem", cursor: "pointer" }}
                          src="/assets/bcimages/bcaffiliate/copy_icon.svg"
                          onClick={() => handleCopy(item.code, "Code")}
                        />
                      </td>
                      <td className="table-refferal-code">
                        <span>{item.link}</span>
                        <img
                          style={{ width: "1rem", cursor: "pointer" }}
                          src="/assets/bcimages/bcaffiliate/copy_icon.svg"
                          onClick={() => handleCopy(item.link, "Link")}
                        />
                      </td>
                      <td>{item.commissionRate}</td>
                      <td>{item.dateCreated}</td>
                      <td
                        onClick={() => handleModal1(item)}
                        className="text-right table-refferal-code-modal"
                      >
                        <span>{item.referrals}</span>
                        <MdKeyboardArrowRight size={18} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="myrewards-refferal-table">
            <div>
              <div className="table-data-filter-search-and-date">
                <div className="table-data-filter-search">
                  <div
                    className="all-codes-options-container"
                    ref={dropdownRef}
                  >
                    <button
                      onClick={toggleOptions}
                      className="main-select-button"
                    >
                      {selectedOption}
                      <div className="calculate-game-select">
                        <MdKeyboardArrowDown size={20} />
                      </div>
                    </button>
                    {isOptionsVisible && (
                      <div className="codes-select-options">
                        <div className="games-select-container">
                          {options.map((option) => (
                            <button
                              className={`games-select-button ${
                                selectedOption === option.label ? "active" : ""
                              }`}
                              onClick={() => handleOptionClick(option)}
                            >
                              {option.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="search-input-box">
                    <input placeholder="Search UserName" />
                    <IoMdSearch className="search-button-input" />
                  </div>
                </div>
                <div className="table-data-filter-date">
                  <div style={{flex: "1 1 0%"}} className="date-range-input-inner">
                    <label className="date-range-label-inner" style={{ marginBottom: "0px" }}>
                      Registration Date:
                    </label>
                    <div className="date-range-input-field">
                      <ReactDatePicker
                        className="date-picker-input-filed"
                        selected={startDate}
                        onChange={(dates) => {
                          setStartDate(dates[0]);
                          setEndDate(dates[1]);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        placeholderText="All Range"
                        dateFormat="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                  <div style={{flex: "1 1 0%"}} className="date-range-input-inner">
                    <label className="date-range-label-inner" style={{ marginBottom: "0px" }}>
                      Registration Date:
                    </label>
                    <div className="date-range-input-field">
                      <ReactDatePicker
                        className="date-picker-input-filed"
                        selected={startDate}
                        onChange={(dates) => {
                          setStartDate(dates[0]);
                          setEndDate(dates[1]);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        placeholderText="All Range"
                        dateFormat="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <table className="refferal-code-and-friends-table">
  <thead>
    <tr
      className="refferal-table-header"
      style={{ borderBottom: "1px solid #e4eaf019" }}
    >
      <th>Username</th>
      <th>User ID</th>
      <th>Commission Rate</th>
      <th>Total Deposits (Past 7D)</th>
      <th>Registration Date</th>
      <th className="text-right">Total Commission</th>
    </tr>
  </thead>
  <tbody>
    {refferalcodeData.map((user, index) => (
      <tr key={index} className="refferal-table-row">
        <td>{user.username}</td>
        <td>{user.userId}</td>
        <td>{user.commissionRate}</td>
        <td>{user.totalDeposits}</td>
        <td>{user.registrationDate}</td>
        <td>{user.totalCommission}</td>
      </tr>
    ))}
  </tbody>
</table>
              <div className="bot-info">
                <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
                  <img
                    className="img-fluid"
                    style={{ width: "12rem", height: "12rem" }}
                    src="\assets\bcimages\bcaffiliate\reward-activity-empty.webp"
                    alt="Empty"
                  />
                  <div className="reward-activities-font mt-4 text-center">
                    <p>No rewards yet. Invite friends to join you now!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleModal}
        contentLabel="Referral Terms & Conditions"
        className="create-campaign-modal"
        overlayClassName="custom-overlay"
      >
        <h2>Create Code</h2>
        <button onClick={handleModal} className="close-modal-button">
          <RxCross2 />
        </button>
        <div className="modal-content-affiliate" style={{ marginTop: "10px" }}>
          <div className="create-campaign-title">
            <p>Campaign Name (Optional)</p>
            <div className="Create-code-modal-input">
              <input
                placeholder="Enter Campaign Name"
                onBlur={(e) => handleCreateCode(e.target.value.trim())}
              />
            </div>
          </div>
          <div>
            <button
              className="create-campaign-button"
              onClick={() => handleCreateCode("")}
            >
              Create Campaign
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isModalOpen1}
        onRequestClose={handleModal1}
        contentLabel="Referral Code Details"
        className="Referral-Code-Details-modal"
        overlayClassName="custom-overlay"
      >
        <h2>Referral Code Details</h2>
        <button onClick={handleModal1} className="close-modal-button">
          <RxCross2 />
        </button>
        {selectedReferral && (
          <div className="Referral-Code-Details-modal-content">
            <div className="refferal-codes-modal-inner">
              <div className="refferal-codes-inner">
                <div className="refferal-codes-table-inner-details">
                  <div className="inner-details-name">
                    <div>Name</div>
                    <div className="inner-details-name-label">
                      {selectedReferral.name}
                    </div>
                  </div>
                  <div className="inner-details-name">
                    <div>Code</div>
                    <div className="inner-details-code-label">
                      {selectedReferral.code}
                      <img
                        style={{
                          width: "1rem",
                          cursor: "pointer",
                          marginLeft: "5px",
                        }}
                        src="/assets/bcimages/bcaffiliate/copy_icon.svg"
                        onClick={() =>
                          handleCopy(selectedReferral.code, "Code")
                        }
                      />
                    </div>
                  </div>
                  <div className="inner-details-name">
                    <div>Link</div>
                    <div className="inner-details-code-label">
                      {selectedReferral.link}
                      <img
                        style={{
                          width: "1rem",
                          cursor: "pointer",
                          marginLeft: "5px",
                        }}
                        src="/assets/bcimages/bcaffiliate/copy_icon.svg"
                        onClick={() =>
                          handleCopy(selectedReferral.link, "Link")
                        }
                      />
                    </div>
                  </div>
                  <div className="inner-details-name">
                    <div>Date Created</div>
                    <div className="inner-details-name-label">
                      {selectedReferral.dateCreated}
                    </div>
                  </div>
                  <div className="inner-details-name">
                    <div>Referrals</div>
                    <div className="inner-details-name-label">
                      {selectedReferral.referrals}
                    </div>
                  </div>
                  <div className="inner-details-name">
                    <div>Commission Rate</div>
                    <div className="inner-details-name-label">
                      {selectedReferral.commissionRate}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="refferal-codes-wager-detais">
              <div className="wager-details-title">Wager</div>
              <div className="wager-details-content">
                <div className="wager-details-content-inner">
                  <div className="wager-details-content-label">
                    Originals ($)
                  </div>
                  <div className="inner-details-name-label">--</div>
                </div>
                <div className="wager-details-content-inner">
                  <div className="wager-details-content-label">
                    Live Casino & 3rd Party Slots ($)
                  </div>
                  <div className="inner-details-name-label">--</div>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                    paddingBottom: ".75rem",
                  }}
                  className="wager-details-content-inner"
                >
                  <div className="wager-details-content-label">Sports ($)</div>
                  <div className="inner-details-name-label">--</div>
                </div>
                <div className="wager-details-content-inner">
                  <div className="wager-details-content-label">
                    Total Wager ($)
                  </div>
                  <div className="inner-details-name-label">--</div>
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "15px" }}
              className="refferal-codes-wager-detais"
            >
              <div className="wager-details-title">Commission</div>
              <div className="wager-details-content">
                <div className="wager-details-content-inner">
                  <div className="wager-details-content-label">
                    Originals ($)
                  </div>
                  <div className="inner-details-name-label">--</div>
                </div>
                <div className="wager-details-content-inner">
                  <div className="wager-details-content-label">
                    Live Casino & 3rd Party Slots ($)
                  </div>
                  <div className="inner-details-name-label">--</div>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                    paddingBottom: ".75rem",
                  }}
                  className="wager-details-content-inner"
                >
                  <div className="wager-details-content-label">Sports ($)</div>
                  <div className="inner-details-name-label">--</div>
                </div>
                <div className="wager-details-content-inner">
                  <div className="wager-details-content-label">
                    Total Commission ($)
                  </div>
                  <div className="inner-details-name-label">--</div>
                </div>
              </div>
            </div>

            <div className="view-friends-list-button">
            <button onClick={() => {
  handleTabClick("referral");
  handleModal1();
}}
>View in Friend list</button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default RefferalCodesAndFriends;
